<script setup>
import { computed } from 'vue';
import { useLimitErrors } from '../../composables/useLimitErrors';
import { useSubscription } from '../../composables/useSubscription';
import UpgradeModal from './UpgradeModal.vue';

const { limitError, clearLimitError } = useLimitErrors();
const { getUpgradePlanForResource } = useSubscription();

const requiredPlan = computed(() =>
  (limitError.value && getUpgradePlanForResource(limitError.value.resource)) || 'starter'
);
</script>

<template>
  <UpgradeModal
    :open="!!limitError"
    :resource="limitError?.resource || ''"
    :current-usage="limitError?.currentUsage || 0"
    :limit="limitError?.limit || 0"
    :required-plan="requiredPlan"
    @close="clearLimitError()"
  />
</template>
